// src/pages/qc/RmSpecParamModal.jsx
import { useState } from "react";

export function RmSpecParamModal({ rmId, param, onSave, onCancel, mandatory = false }) {
  const [parameter,     setParameter]     = useState(param?.parameter     ?? "");
  const [uom,           setUom]           = useState(param?.uom           ?? "");
  const [minValue,      setMinValue]      = useState(param?.minValue      ?? "");
  const [maxValue,      setMaxValue]      = useState(param?.maxValue      ?? "");
  const [testMethod,    setTestMethod]    = useState(param?.testMethod    ?? "");
  const [expectedValue, setExpectedValue] = useState(param?.expectedValue ?? "");
  const [saving,        setSaving]        = useState(false);
  const [err,           setErr]           = useState("");

  async function handleSave() {
    if (!parameter.trim()) { setErr("Parameter name is required"); return; }
    setSaving(true); setErr("");
    try {
      await onSave({
        parameter:     parameter.trim(),
        uom:           uom || null,
        minValue:      minValue !== "" ? Number(minValue) : null,
        maxValue:      maxValue !== "" ? Number(maxValue) : null,
        testMethod:    testMethod || null,
        expectedValue: expectedValue || null,
      });
    } catch(e) { setErr(e.message); }
    finally { setSaving(false); }
  }

  return (
    <div className="modal">
      <div className="modal-header">
        <h3 className="modal-title">
          {mandatory ? `Add First Specification — ${rmId}` : param ? "Edit Parameter" : `Add Parameter — ${rmId}`}
        </h3>
        {!mandatory && <button className="btn" onClick={onCancel}>✕</button>}
      </div>
      {mandatory && (
        <div className="alert-info" style={{ margin:"0 0 12px" }}>
          At least one specification parameter is required for every new RM. Add the first parameter below.
        </div>
      )}
      {[
        ["Parameter",   <input className="form-input" style={{ flex:1 }} value={parameter} onChange={e => setParameter(e.target.value)} />],
        ["UOM",         <input className="form-input" style={{ flex:1 }} value={uom} onChange={e => setUom(e.target.value)} placeholder="e.g. %, cP, mg/L" />],
        ["Min",            <input className="form-input input-right" style={{ width:120 }} type="number" step="any" value={minValue} onChange={e => setMinValue(e.target.value)} />],
        ["Max",            <input className="form-input input-right" style={{ width:120 }} type="number" step="any" value={maxValue} onChange={e => setMaxValue(e.target.value)} />],
        ["Expected Value", <input className="form-input" style={{ flex:1 }} value={expectedValue} onChange={e => setExpectedValue(e.target.value)} placeholder="e.g. Liquid, Clear, None" />],
        ["Test Method",    <input className="form-input" style={{ flex:1 }} value={testMethod} onChange={e => setTestMethod(e.target.value)} placeholder="e.g. ASTM D445" />],
      ].map(([lbl, input]) => (
        <div className="form-row" key={lbl}>
          <span className="form-label">{lbl}</span>{input}
        </div>
      ))}
      {err && <div className="alert-warn" style={{ marginTop:8 }}>{err}</div>}
      <div className="form-sep" />
      <div className="form-footer">
        <button className="btn" onClick={onCancel}>Cancel</button>
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? "Saving…" : param ? "Save Changes" : "Add Parameter"}
        </button>
      </div>
    </div>
  );
}
